import { render, staticRenderFns } from "./VerifyBank.vue?vue&type=template&id=5c02c8f5&scoped=true&"
var script = {}
import style0 from "./VerifyBank.vue?vue&type=style&index=0&id=5c02c8f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c02c8f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
